import { useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';

import { BackIcon } from '@/assets/icons';
import ButtonWrap from '@/components/ButtonWrap';
import IconWrap from '@/components/IconWrap';
import './style.scss';
import DatePickerWrap from '@/components/DatePickerWrap';
import { Moment } from 'moment';
import moment from 'moment';
import CheckBoxWrap from '@/components/CheckBoxWrap';
import SelectWrap from '@/components/SelectWrap';
import { useState } from 'react';

interface IActionButton {
    title: string;
    url: string;
    icon?: React.ReactNode;
}

interface IActionDateFilter {
    title?: string;
    value: Moment;
    onChange?: (data: any) => void;
}

interface IProps {
    title?: string;
    storeName?: string;
    dateFilter?: string;
    actions?: IActionButton[];
    isBack?: boolean;
    isImport?: boolean;
    multipleStore?: boolean;
    api?: string;
    actionFilter?: IActionDateFilter;
    onHandleModal?: () => void;
}

export const HeaderLayout: React.FC<IProps> = ({
    title,
    actions,
    isBack = false,
    storeName,
    dateFilter,
    actionFilter,
}) => {
    const navigate = useNavigate();

    const queryClient = useQueryClient();

    const [picker, setPicker] = useState<'date' | 'time' | 'month' | 'quarter' | 'year' | undefined>('date');
    const [value, setValue] = useState(moment(actionFilter?.value));

    const onGoPage = (e: any) => {
        queryClient.clear();
        navigate(-1);
    };

    return (
        <div className="c-header">
            <div className="c-header__title">
                {isBack && <IconWrap onClick={onGoPage} icon={<BackIcon />} />}
                <h1>
                    <span className="no-print">{title}</span>
                    <span className="print">{title?.split('/')[1] || ''}</span>
                    <span className="print">{storeName}</span>
                    <span className="print">{dateFilter}</span>
                </h1>
            </div>
            <div className="c-header__right">
                {actionFilter && (
                    <div className="c-header__filter">
                        {!actionFilter.title ? (
                            <SelectWrap
                                className="select_filter_date"
                                size={'large'}
                                defaultValue={'day'}
                                onChange={(value: string) => {
                                    if (value === 'day') {
                                        setPicker('date');
                                    } else {
                                        setPicker('month');
                                    }
                                    setValue(moment());
                                    const day = moment().format(value === 'month' ? 'YYYY/MM' : 'YYYY/MM/DD');
                                    return actionFilter.onChange ? actionFilter.onChange(day) : undefined;
                                }}
                                options={[
                                    {
                                        id: 'day',
                                        value: 'Ngày',
                                    },
                                    {
                                        id: 'month',
                                        value: 'Tháng',
                                    },
                                ]}
                            />
                        ) : (
                            <h1>{actionFilter.title}</h1>
                        )}

                        <DatePickerWrap
                            suffixIcon
                            value={value}
                            picker={picker}
                            className={'select-datepicker'}
                            onChange={(day: any) => {
                                if (typeof day === 'object') {
                                    day = moment(day).format(picker === 'month' ? 'YYYY/MM' : 'YYYY/MM/DD');
                                }
                                setValue(moment(day));
                                return actionFilter.onChange ? actionFilter.onChange(day) : undefined;
                            }}
                        />
                    </div>
                )}

                <div className="c-header__action">
                    {actions?.length &&
                        actions.map(({ title, url, icon }, index) => (
                            <ButtonWrap
                                key={index}
                                height={37}
                                icon={<IconWrap icon={icon} />}
                                text={title}
                                type="primary"
                                onClick={() => {
                                    navigate(url);
                                }}
                            />
                        ))}
                </div>
            </div>
        </div>
    );
};
